// extracted by mini-css-extract-plugin
export var copyIcon = "_xz-2";
export var discountCard = "_xz-0";
export var discountCode = "_xz-3";
export var discountContent = "_xz-1";
export var loadingCard = "_xz-4";